import { Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";

export default function Year({ controlId, tooltip, isValid, defaultValue, onChange }) {
  function getDropList() {
    const year = new Date().getFullYear() - 1900;

    return Array.from(new Array(year + 2), (v, i) => (
      <option key={i} value={1900 + i}>
        {1900 + i}
      </option>
    ));
  }
  function handleChange(event) {
    onChange(event);
  }

  return (
    <OverlayTrigger
      rootClose
      placement="right-start"
      trigger={tooltip ? ["hover"] : ""}
      overlay={
        <Tooltip id="overlay-example" className="helpTooltip year">
          <strong>Year Started</strong>
          <br />
          This is the date on which the entity began doing business. If you are starting a new business, enter the
          starting date of the business. If the business you acquired is already operating, enter the date you acquired
          the business. If you are changing the form of ownership of your business, enter the date the new ownership
          entity began.
        </Tooltip>
      }
    >
      <Form.Group as={Col} controlId={controlId}>
        <Form.Control
          as="select"
          data-hj-allow
          isInvalid={isValid !== undefined && !isValid}
          value={defaultValue}
          onChange={handleChange}
        >
          {getDropList()}
        </Form.Control>
        <Form.Control.Feedback type="invalid">Please provide year</Form.Control.Feedback>
      </Form.Group>
    </OverlayTrigger>
  );
}
